import React, { MouseEvent, ReactNode } from 'react';
import { Flex } from 'UI/Flex';
import { StyledDashedButton } from './DashedButton.styled';

export interface DashedButtonProps {
  children?: ReactNode | string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  isActive?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  'data-cy'?: string;
  className?: string;
  htmlType?: 'submit' | 'button';
}

export const DashedButton = ({
  children,
  iconLeft,
  iconRight,
  isActive,
  onClick,
  disabled,
  'data-cy': dataCy,
  className,
  htmlType = 'button',
}: DashedButtonProps) => {
  return (
    <StyledDashedButton
      onClick={onClick}
      disabled={disabled}
      $isActive={isActive}
      type={htmlType}
      data-cy={dataCy}
      className={className}
    >
      <Flex align={'center'} justify={'center'} gap={8}>
        {iconLeft}
        {children}
        {iconRight}
      </Flex>
    </StyledDashedButton>
  );
};
